import { useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { CheckboxInput } from '@hivebrite/design-system/Inputs';

import Modal from 'hb-react/shared/components/DesignSystem/Modal';

import ModalActions from './ModalActions';

const ModalContent = ({ closeModal, id, itemName, onConfirm }) => {
  const [skipConfirmation, setSkipConfirmation] = useState(false);

  return (
    <Modal isFocusOnRef={false} center onCloseModal={closeModal}>
      {({ closeButton }) => (
        <>
          {closeButton}
          <ModalContentWrapper>
            <Title>{s__('Delete %{itemName}').i__({ itemName })}</Title>
            <Paragraph>
              {s__(
                'Builder|Do you want to permanently delete this %{itemName}? You will not be able to recover the content if you do so.',
              ).i__({ itemName })}
            </Paragraph>
            <SkipConfirmationCheckBox>
              <CheckBox>
                <CheckboxInput
                  value={skipConfirmation}
                  id="skipConfirmationChoice"
                  name="skipConfirmationChoice"
                  onChange={() => setSkipConfirmation(!skipConfirmation)}
                />
              </CheckBox>
              <Box ml="10px"> {__("Don't show me this message again")}</Box>
            </SkipConfirmationCheckBox>
            <ModalActions
              skipConfirmation={skipConfirmation}
              closeModal={closeModal}
              onConfirm={onConfirm}
              id={id}
            />
          </ModalContentWrapper>
        </>
      )}
    </Modal>
  );
};

export default ModalContent;

const ModalContentWrapper = styled(Box).attrs(() => ({
  bg: 'white',
  flexDirection: 'column',
  p: 20,
  margin: '0 auto',
  maxWidth: '640px',
}))`
  position: relative;
`;

const Title = styled(Box).attrs(() => ({
  font: 'h3-semibold',
  color: 'asphalt',
  mb: '10px',
  width: '100%',
}))``;

const Paragraph = styled(Box).attrs(() => ({
  font: 'p-semibold',
  mb: 5,
  width: '100%',
}))``;

const SkipConfirmationCheckBox = styled(Box).attrs(() => ({
  alignItems: 'center',
}))``;

const CheckBox = styled(Box).attrs(() => ({
  width: 'auto',
}))``;
